import { useState } from "react";

export interface FirstVisitState {
  selectedSource: string;
  selectedSubSource: string;
  selectedSubSubSource: string;
  subSourceTexts: Record<string, string>;
  otherSourceText: string;
  isSubmitting: boolean;
}

export const useFirstVisitState = () => {
  const [selectedSource, setSelectedSource] = useState<string>("");
  const [selectedSubSource, setSelectedSubSource] = useState<string>("");
  const [selectedSubSubSource, setSelectedSubSubSource] = useState<string>("");
  const [subSourceTexts, setSubSourceTexts] = useState<Record<string, string>>({});
  const [otherSourceText, setOtherSourceText] = useState<string>("");
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  const resetState = () => {
    setSelectedSource("");
    setSelectedSubSource("");
    setSelectedSubSubSource("");
    setSubSourceTexts({});
    setOtherSourceText("");
    setIsSubmitting(false);
  };

  const updateSubSourceText = (id: string, value: string) => {
    setSubSourceTexts((prev) => ({
      ...prev,
      [id]: value,
    }));
  };

  const clearSubSourceTexts = () => {
    setSubSourceTexts({});
  };

  return {
    // State
    selectedSource,
    selectedSubSource,
    selectedSubSubSource,
    subSourceTexts,
    otherSourceText,
    isSubmitting,
    
    // Setters
    setSelectedSource,
    setSelectedSubSource,
    setSelectedSubSubSource,
    setOtherSourceText,
    setIsSubmitting,
    
    // Actions
    resetState,
    updateSubSourceText,
    clearSubSourceTexts,
  };
};
